import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  components,
  computed,
  data,
  methods
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/user/resources/index.js